import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/inspectionRecord',
  component: LAYOUT,
  name: 'InspectionRecord',
  redirect: '/inspectionRecord/index',
  meta: {
    title: '检测记录',
  },
  children: [
    {
      path: 'index',
      name: 'InspectionRecordIndex',
      meta: {
        title: '检测记录',
      },
      component: () => import('@/views/inspectionRecord/index'),
    },
  ],
};
